import { render, staticRenderFns } from "./SampleTable.vue?vue&type=template&id=b32595d8"
import script from "./SampleTable.vue?vue&type=script&lang=ts"
export * from "./SampleTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports